@for (key of renderKeys(); track key) {
  <app-end-client-report-page [reportId]="key" [paletteOverride]="palette" [logoOverride]="logo"></app-end-client-report-page>
}
